import { Outlet } from 'react-router-dom';
import {
  IconNavChartPie,
  IconNavFlag,
  IconNavWallet,
} from '../../components/icons';
import { AppShellGrid, type NavEntry } from '../../components/Sidebar';
import { useDict } from '../../i18n/dictionary';
import { useAppCrumb } from '../../layouts/AppLayout';
import { financesDict } from './i18n';

export function FinancesLayout() {
  const t = useDict(financesDict);
  useAppCrumb('finances', t.appName, '/finances');
  const nav: NavEntry[] = [
    {
      key: 'overview',
      href: '/finances',
      label: t.overview,
      icon: IconNavChartPie,
      end: true,
    },
    {
      key: 'wallets',
      href: '/finances/wallets',
      label: t.wallets,
      icon: IconNavWallet,
    },
    {
      key: 'goals',
      href: '/finances/goals',
      label: t.goals,
      icon: IconNavFlag,
    },
  ];
  return (
    <AppShellGrid items={nav}>
      <Outlet />
    </AppShellGrid>
  );
}
